// ==============================================================================================
//  APPLICATION AUTHORSHIP & RIGHTS NOTICE
//
//  Developed by: Gareth Morgan
//  Brand & Product: BuildMyChecks.co.uk
//  Ownership: Sole author and rights holder
//
//  ----------------------------------------------------------------------------------------------
//  NOTICE:
//  - This application and its related systems were designed, developed, and built solely
//    by Gareth Morgan.
//  - Gareth Morgan retains full authorship, intellectual property, and creative rights to
//    all Build My Checks branding, technology, source code, architecture, and design.
//  - No ownership, license, or implied rights are granted to any third party unless
//    explicitly agreed in writing by Gareth Morgan.
//  - Gareth Morgan is NOT responsible for future maintenance, updates, security patching,
//    or operational upkeep if this application is deployed, copied, or modified without
//    his written consent.
//  - Gareth Morgan reserves the right to:
//        Withdraw or disable access to the application or related services
//        Remove hosted, cloud-based, or linked services under his control
//        Revoke access to Build My Checksrelated assets, code, APIs, or integrations
//
//   2025 Gareth Morgan  BuildMyChecks.co.uk
//  Unauthorized use, alteration, copying, or redistribution without written consent
//  is strictly prohibited.
//
//  ----------------------------------------------------------------------------------------------
//  Build My Checks  ASCII Logo Signature
//  (Symbolic representation of BuildMyChecks.co.uk identity)
//
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................:-==++-.........:-:.............................................
// ...................................-*******:.......=*****+-.........................................
// ...................................=*******+:.....+*******=.........................................
// .........................::........+**********************=.........................................
// .......................-+***+-.:-++***********************=:.......:................................
// .....................-+*************************************+-..=+**+-..............................
// .....................:+*************+=-.............-++***************+:............................
// ......................:+********+=:.....................:=*************=............................
// .......................=******+:...........................-+********+-.............................
// ......................-*****+:...............................-+*****+-..............................
// ................:::::+****+-...................................=*****+..............................
// ...............+-......:=+-........+=.*%=......##:.:::.....:::..-*****=.............................
// ..............=*-*@%%%%@*.........-#*:#@=......@%::@@@*...*@@#...-+++++**++=-.......................
// .............:**-*@*..=@%.=#+..*#=-%#:#@=.=#%#+@%::@%%%-.=@%@#-##:..##:+*****:......................
// ..............-+-*@@%%@%+.+@*..#@==%#:#@==@%-:+@%::@#-@#:%#+%#.+@#.*@+-******=......................
// .................*@*..:#@++@*..#@==%#:#@=+@#...@%::@#.+@%%-=%#..%@#%#:+******+......................
// .................*@%##%@#.-%@%%@@==%#:#@=:#@%#%%%::@#.:#@*.=%#...%@%:=****+-:.......................
// ..................::........::.........:....::.....:....:......:-#@--***+:..........................
// ................:++:+@@@@@*.:@#:.....................#%=......:#%#-.+***+:..........................
// .............-+**+:#@*:.:+%+:@#-=+-...:=+=-....-+=-..#%=.:=-..-++-..+***+:..........................
// .............+***=-@%.......:@@#+#@#.+@#-+%#:+@%++@%:#%+*@#::%#--*-:*****+-.........................
// .............-***=:@%.......:@%:.-%%:%@%%%%%+#@=.....#@@@%:..#%@@%-=**+++++*+.......................
// ..............****-+%@*=+%@*:@%:.-%%.*@*-=*=.*@%==%#:#@+=@%=:++-+@*-+--===:+=.......................
// .................::::=***=:..++..:++..-+**=...:+**+:.=+-.:++:-*#*=::-:+***=::-++:...................
// ....................-****+=............................*#......+*****************=..................
// .....................=*****=.......+##+.:+##=....*+.-#-*#.**:..:+************++*=...................
// .....................+******+-....*%..:.%*.:%+..:%*.=%=*%%*..:--***********+:..-+:..................
// ....................+*********=:%=+%*+%-*%+*%-=#-#%*%@=*#:%*:+****+++****+=...=*****-...............
// ...................=**********+--::.::....::...:..::.:.:-::-:=***+:..=+*+:..:+******-...............
// ....................-******++*******+=-:............-=++****+=+***+:...:...=******+-:...............
// ......................-++-....=+***************************+=+-=****+:...-+******-..................
// ................................=**********************++-:....=******=:+********=..................
// ................................=**********************=......:+*****************+:.................
// ................................+*******=......+*******=........-+=.:=+****+-.-+-...................
// ................................:-=+***-........+******=..............=***+.........................
// .................................................--::...............................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
//
// ==============================================================================================

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import BuildMyChecksSocialLinks from '../../components/BuildMyChecksSocialLinks';
import logo from '../../assets/image/logo_web.png';
import { useTranslation } from 'react-i18next';

export default function Pricing() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-red-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-extrabold mb-6">{t('subscription.pricingTitle')}</h1>
          <p className="text-2xl mb-4">{t('subscription.pricingSubtitle')}</p>
          <p className="text-xl max-w-3xl mx-auto">
            {t('subscription.pricingDescription')}
          </p>
        </div>
      </section>

      {/* Main Pricing */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto">
          {/* Pricing Card */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="bg-gradient-to-br from-primary to-red-700 text-white text-center py-12 px-8">
              <h2 className="text-3xl font-bold mb-4">{t('subscription.professionalPlan')}</h2>
              <div className="mb-6">
                <span className="text-6xl font-extrabold">{t('subscription.pricePerUser')}</span>
                <span className="text-2xl">{t('subscription.perUserMonth')}</span>
              </div>
              <p className="text-xl opacity-90">{t('subscription.everythingYouNeed')}</p>
            </div>

            <div className="p-12">
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                {/* Core Features */}
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-3xl mr-3">✨</span>
                    {t('subscription.coreFeatures')}
                  </h3>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.unlimitedForms')}</strong> - {t('subscription.unlimitedFormsDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.unlimitedSubmissions')}</strong> - {t('subscription.unlimitedSubmissionsDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.mobileWebAccess')}</strong> - {t('subscription.mobileWebAccessDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.cloudStorage')}</strong> - {t('subscription.cloudStorageDesc')}</span>
                    </li>
                  </ul>
                </div>

                {/* Advanced Features */}
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-3xl mr-3">🚀</span>
                    {t('subscription.advancedFeatures')}
                  </h3>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.photosSignatures')}</strong> - {t('subscription.photosSignaturesDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.pdfExports')}</strong> - {t('subscription.pdfExportsDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.roleBasedAccessShort')}</strong> - {t('subscription.roleBasedAccessDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.approvalWorkflows')}</strong> - {t('subscription.approvalWorkflowsDesc')}</span>
                    </li>
                  </ul>
                </div>

                {/* Team Features */}
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-3xl mr-3">👥</span>
                    {t('subscription.teamCollaboration')}
                  </h3>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.userManagement')}</strong> - {t('subscription.userManagementDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.groupManagement')}</strong> - {t('subscription.groupManagementDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.scheduledInspections')}</strong> - {t('subscription.scheduledInspectionsDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.realTimeSync')}</strong> - {t('subscription.realTimeSyncDesc')}</span>
                    </li>
                  </ul>
                </div>

                {/* Support & Security */}
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-3xl mr-3">🔒</span>
                    {t('subscription.supportSecurity')}
                  </h3>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.priorityEmailSupport')}</strong> - {t('subscription.priorityEmailSupportDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.gdprCompliant')}</strong> - {t('subscription.gdprCompliantDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.dailyBackups')}</strong> - {t('subscription.dailyBackupsDesc')}</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span><strong>{t('subscription.regularUpdates')}</strong> - {t('subscription.regularUpdatesDesc')}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="text-center pt-8 border-t">
                <button
                  onClick={() => navigate('/register')}
                  className="bg-primary hover:bg-red-700 text-white px-12 py-4 rounded-lg text-xl font-semibold shadow-lg"
                >
                  {t('subscription.startFreeTrialBtn')}
                </button>
                <p className="text-gray-600 mt-4">{t('subscription.noCreditCardCancel')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Calculator */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl p-12">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">{t('subscription.calculateCost')}</h2>
            
            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <PricingCalculator />
            </div>

            <p className="text-gray-600 mt-8 text-lg">
              {t('subscription.simpleMath')}
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">{t('subscription.faqTitle')}</h2>
        
        <div className="space-y-6">
          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-3">{t('subscription.faqTrialQ')}</h3>
            <p className="text-gray-600">{t('subscription.faqTrialA')}</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-3">{t('subscription.faqCancelQ')}</h3>
            <p className="text-gray-600">{t('subscription.faqCancelA')}</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-3">{t('subscription.faqPaymentQ')}</h3>
            <p className="text-gray-600">{t('subscription.faqPaymentA')}</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-3">{t('subscription.faqDiscountQ')}</h3>
            <p className="text-gray-600">{t('subscription.faqDiscountA')}</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-3">{t('subscription.faqMidMonthQ')}</h3>
            <p className="text-gray-600">{t('subscription.faqMidMonthA')}</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-3">{t('subscription.faqSetupFeeQ')}</h3>
            <p className="text-gray-600">{t('subscription.faqSetupFeeA')}</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-3">{t('subscription.faqRefundQ')}</h3>
            <p className="text-gray-600">{t('subscription.faqRefundA')} {t('subscription.faqRefundSeeOur')} <button onClick={() => navigate('/refund-policy')} className="text-primary hover:underline">{t('footer.refundPolicy')}</button> {t('subscription.faqRefundForDetails')}</p>
          </div>
        </div>
      </section>

      {/* BuildMyShifts Pricing Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              {t('subscription.bms.partOfPlatform')}
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('subscription.bms.title')}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t('subscription.bms.subtitle')}</p>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-blue-200">
            <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white text-center py-12 px-8">
              <div className="flex items-center justify-center gap-3 mb-4">
                <img src="https://buildmyshifts.com/logo.png" alt="BuildMyShifts" className="w-10 h-10 rounded-lg" />
                <h3 className="text-3xl font-bold">{t('subscription.bms.planName')}</h3>
              </div>
              <div className="mb-4">
                <span className="text-6xl font-extrabold">{t('subscription.bms.price')}</span>
                <span className="text-2xl">{t('subscription.bms.perMonth')}</span>
              </div>
              <p className="text-xl opacity-90">{t('subscription.bms.description')}</p>
            </div>

            <div className="p-12">
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                {/* Scheduling */}
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-3xl mr-3">📅</span>
                    {t('subscription.bms.scheduling')}
                  </h4>
                  <ul className="space-y-4">
                    {['unlimitedRotas', 'multiWeekViews', 'shiftSwapBoard', 'coverageForecasting'].map((key) => (
                      <li key={key} className="flex items-start">
                        <svg className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        <span><strong>{t(`subscription.bms.${key}`)}</strong> - {t(`subscription.bms.${key}Desc`)}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Smart Features */}
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-3xl mr-3">🤖</span>
                    {t('subscription.bms.smartFeatures')}
                  </h4>
                  <ul className="space-y-4">
                    {['aiAutoFill', 'timeClock', 'payrollExport', 'analytics'].map((key) => (
                      <li key={key} className="flex items-start">
                        <svg className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        <span><strong>{t(`subscription.bms.${key}`)}</strong> - {t(`subscription.bms.${key}Desc`)}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Team Management */}
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-3xl mr-3">👥</span>
                    {t('subscription.bms.teamManagement')}
                  </h4>
                  <ul className="space-y-4">
                    {['staffProfiles', 'accreditations', 'groupsLocations', 'roleBasedAccess'].map((key) => (
                      <li key={key} className="flex items-start">
                        <svg className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        <span><strong>{t(`subscription.bms.${key}`)}</strong> - {t(`subscription.bms.${key}Desc`)}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Compliance & Reports */}
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                    <span className="text-3xl mr-3">📊</span>
                    {t('subscription.bms.complianceReports')}
                  </h4>
                  <ul className="space-y-4">
                    {['wtdCompliance', 'reportsExport', 'auditLog', 'notifications'].map((key) => (
                      <li key={key} className="flex items-start">
                        <svg className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        <span><strong>{t(`subscription.bms.${key}`)}</strong> - {t(`subscription.bms.${key}Desc`)}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Bundle Discount Banner */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-2xl p-6 mb-8">
                <div className="flex items-center justify-center gap-4 flex-wrap">
                  <div className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-bold">
                    {t('subscription.bms.save50')}
                  </div>
                  <p className="text-gray-700 font-medium text-center">
                    {t('subscription.bms.bundleMessage')}
                  </p>
                </div>
              </div>

              <div className="text-center pt-8 border-t">
                <a
                  href="https://buildmyshifts.com/register"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-12 py-4 rounded-lg text-xl font-semibold shadow-lg transition-colors"
                >
                  {t('subscription.bms.startTrial')}
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
                <p className="text-gray-600 mt-4">{t('subscription.bms.trialDetails')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-primary text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">{t('subscription.readyToStart')}</h2>
          <p className="text-xl mb-8">
            {t('subscription.joinHundreds')}
          </p>
          <button
            onClick={() => navigate('/register')}
            className="bg-white text-primary hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold shadow-lg"
          >
            {t('subscription.startYourTrial')}
          </button>
          <p className="text-sm mt-4 opacity-90">{t('subscription.trialDetails')}</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-lg font-bold mb-4">{t('common.brandName')}</h3>
              <p className="text-gray-400 text-sm">{t('footer.description')}</p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">{t('footer.product')}</h4>
              <ul className="space-y-2 text-sm">
                <li><button onClick={() => navigate('/features')} className="text-gray-400 hover:text-white">{t('nav.features')}</button></li>
                <li><button onClick={() => navigate('/pricing')} className="text-gray-400 hover:text-white">{t('nav.pricing')}</button></li>
                <li><button onClick={() => navigate('/register')} className="text-gray-400 hover:text-white">{t('subscription.startFreeTrialBtn')}</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">{t('footer.company')}</h4>
              <ul className="space-y-2 text-sm">
                <li><button onClick={() => navigate('/contact')} className="text-gray-400 hover:text-white">{t('nav.contact')}</button></li>
                <li><button onClick={() => navigate('/privacy')} className="text-gray-400 hover:text-white">{t('footer.privacyPolicy')}</button></li>
                <li><button onClick={() => navigate('/terms')} className="text-gray-400 hover:text-white">{t('footer.termsOfService')}</button></li>
                <li><button onClick={() => navigate('/refund-policy')} className="text-gray-400 hover:text-white">{t('footer.refundPolicy')}</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">{t('footer.contactTitle')}</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>support@buildmychecks.co.uk</li>
                <li>sales@buildmychecks.co.uk</li>
                <li className="pt-4">
                  <BuildMyChecksSocialLinks />
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-400">
            <p>{t('common.copyrightFull', { year: new Date().getFullYear() })}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

// Simple pricing calculator component
function PricingCalculator() {
  const { t } = useTranslation();
  const [users, setUsers] = React.useState(5);
  const monthlyTotal = users * 5;
  const annualTotal = monthlyTotal * 12;

  return (
    <div>
      <div className="mb-8">
        <label className="block text-lg font-semibold text-gray-900 mb-4">
          {t('subscription.howManyUsers')}
        </label>
        <input
          type="range"
          min="1"
          max="100"
          value={users}
          onChange={(e) => setUsers(parseInt(e.target.value))}
          className="w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer"
        />
        <div className="flex justify-between text-sm text-gray-600 mt-2">
          <span>{t('subscription.oneUser')}</span>
          <span>{t('subscription.hundredUsers')}</span>
        </div>
      </div>

      <div className="bg-gradient-to-br from-primary to-red-700 text-white rounded-2xl p-8 mb-6">
        <div className="text-center">
          <div className="text-6xl font-bold mb-2">{users}</div>
          <div className="text-xl mb-6">{t('subscription.users')}</div>
          
          <div className="border-t border-white/30 pt-6">
            <div className="text-sm opacity-80 mb-2">{t('subscription.monthlyCost')}</div>
            <div className="text-4xl font-bold">£{monthlyTotal}</div>
            <div className="text-sm opacity-80 mt-4">{t('subscription.annualCost')}</div>
            <div className="text-2xl font-semibold">£{annualTotal}</div>
          </div>
        </div>
      </div>

      <div className="text-sm text-gray-600">
        <p className="mb-2"><strong>{t('subscription.includes')}</strong></p>
        <ul className="list-disc list-inside space-y-1">
          <li>{t('subscription.includesUnlimited')}</li>
          <li>{t('subscription.includesAllFeatures')}</li>
          <li>{t('subscription.includesMobileWeb')}</li>
          <li>{t('subscription.includesPriority')}</li>
        </ul>
      </div>
    </div>
  );
}

// ----------------------------------------------------------------------------------------------
//  Build My Checks (c) 2025 Gareth Morgan - BuildMyChecks.co.uk
//  Solely designed, developed, and maintained by Gareth Morgan.
//  All intellectual property rights reserved.
//  No liability is accepted for unauthorised use, modification, deployment, or maintenance.
// ----------------------------------------------------------------------------------------------
